export default "__VITE_ASSET__Dyqsa$CD__"